export default __webpack_public_path__ + "45a0dda881e2eced3c8dd48eb1be4b0c.png";